/**
 * Cómo se nombra una fila del detalle de un contador.  (002 · FR-014)
 *
 * El listado ya no trae hilos que Chatwoot borró (025 · FR-003): se
 * apartan antes de pintar. Si aun así llega la marca, no se disfraza
 * de «Sin nombre».
 */
export function etiquetaPersonaContador(i: {
    persona: string | null
    hiloBorrado?: boolean
}): string {
    if (i.hiloBorrado) return 'Hilo borrado'
    const nombre = i.persona?.trim()
    return nombre ? nombre : 'Sin nombre'
}
